import { render } from "./template.html?vue&type=template&id=d5cfaa8c&scoped=true&ts=true&external"
import script from "./AppHeader.vue?vue&type=script&lang=ts"
export * from "./AppHeader.vue?vue&type=script&lang=ts"

import "./style.scss?vue&type=style&index=0&id=d5cfaa8c&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5cfaa8c"]])

export default __exports__